import { AES, enc } from 'crypto-js';
import Cookies from 'cookies-js';
import { successLoader } from '../../Redux/_actions/loader.action';
import store from '../../Redux/_helpers/store';
import {invalidTokenPath,logoutPath} from '../config/apiGateway';

const Logout = function () {
    // auth token
    const testAccess = Cookies.get('_msAL');
    // refresh token
    const refreshToken = sessionStorage.getItem("isAuthenticated")
    const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
    const decryptedObject = decrypted.toString(enc.Utf8);
    const getRefreshToken = JSON.parse(decryptedObject)
    // const isTokenAvailable =  sessionStorage.getItem("Decrypted Token")
    // const tokenDetails = JSON.parse(isTokenAvailable)
    //start
    store.dispatch(successLoader(false));
    fetch(invalidTokenPath, {
        method: 'GET',
        headers: {
            //  'id_token_hint':tokenDetails.tokenResponse.id_token,
            Authorization: 'Bearer' + ` ${testAccess}`,
            refresh_token: getRefreshToken.tokenResponse.refresh_token,
            'Access-Control-Allow-Origin': '*'
        }
    })
        .then(res => {
            return res;
        })
        .then(data => {
            Cookies.expire('reduxPersistIndex');
            Cookies.expire('persist%3Aroot');
            Cookies.expire('msAL', { path: '/' });
            localStorage.clear();
            sessionStorage.clear();
            console.log("token value", data);
            window.location.replace(logoutPath)
            //end
            store.dispatch(successLoader(true));
        });
}
export default Logout;